import React from "react"
import Translation from "components/Translation"
import MuiFormHelperText from "@material-ui/core/FormHelperText"

type BaseFieldExtraHelperTextProps = {
  extraHelperText?: string
  label?: string
  disabled?: boolean
}

export const FormHelperText = ({ extraHelperText, label, disabled }: BaseFieldExtraHelperTextProps) =>
  extraHelperText ? (
    <MuiFormHelperText id={label} disabled={disabled}>
      <Translation label={extraHelperText} />
    </MuiFormHelperText>
  ) : null
